import { ORIGINAL_ACTION_TICK_MS } from '../shared/attack-timing';

/** ArrowView changes once on every keyDown, then holds for 100ms after its
 * first native frame. OS repeats reset that hold, as in the original code. */
export class AimCadence {
  private lastFrame: number | null = null;
  private firstFrame: number | null = null;
  keyDown(now: number) { this.lastFrame = Math.floor(now / ORIGINAL_ACTION_TICK_MS); this.firstFrame = null; }
  advance(now: number) {
    const frame = Math.floor(now / ORIGINAL_ACTION_TICK_MS);
    if (this.lastFrame === null || frame <= this.lastFrame) return 0;
    this.firstFrame ??= this.lastFrame + 1;
    const eligible = this.firstFrame + Math.ceil(100 / ORIGINAL_ACTION_TICK_MS);
    const steps = Math.max(0, frame - Math.max(this.lastFrame, eligible - 1));
    this.lastFrame = frame;
    return Math.min(3, steps);
  }
  reset() { this.lastFrame = this.firstFrame = null; }
}
